<template>
  <div
    class="flexbox chatcontentbox"
    :style="{
      justifyContent: senderIsSelf ? 'flex-end' : 'flex-start',
      paddingRight: senderIsSelf ? '0px' : '40%',
      paddingLeft: senderIsSelf ? '40%' : '0px',
    }"
  >
    <div class="pop-right" v-if="senderIsSelf">
      <Expression v-if="data.type == 'text'" :text="data.content" />
      <img
        style="width: 100px; height: auto"
        v-else-if="data.type == 'img' && (+vip === 2 || isService == 1)"
        :src="imgurl + data.img"
        :preview-src-list="[imgurl + data.img]"
         @click="showImageViewer = true; imageList = [imgurl + data.img]"
      />
  
      <div v-else-if="data.type == 'img' && +vip !== 2" class="image-slot">
        <i style="font-size: 30px;" class="el-icon-picture-outline"></i>
      </div>

      <span class="ndate">{{ data.ndate }}</span>
    </div>
    <div class="pop-left" v-else>
      <Expression v-if="data.type == 'text'" :text="data.content" />
      <img
         style="width: 100px; height: auto"
        v-else-if="data.type == 'img' && (+vip === 2 || isService == 1)"
        :src="imgurl + data.img"
        @click="showImageViewer = true; imageList = [imgurl + data.img]"
      />
      
      <div v-else-if="data.type == 'img' && +vip !== 2" class="image-slot">
        <i
          style="font-size: 30px;color:#ebeef5;"
          class="el-icon-picture-outline"
        ></i>
      </div>
      <span class="ndate">{{ data.ndate }}</span>
    </div>
    <el-image-viewer @close="closeImgViewer" :url-list="imageList" v-if="showImageViewer"/>

  </div>
</template>

<script>
import Expression from "./Expression.vue";
import { imgurl } from "../common/project.config";
export default {
  props: ["data", "isService"],
  components: {
    Expression,
  },
  data() {
    return {
      showImageViewer: false,
      imageList: [],
    }
  },
  computed: {
    // 判断是不是自己发送的
    senderIsSelf() {
      if (this.$store.state.User.id == this.data.sender_id) {
        return true;
      } else {
        return false;
      }
    },
    vip() {
      return this.$store.state.User.vip;
    },
  },
  methods: {
    closeImgViewer() {
      this.showImageViewer = false
    }
  }
};
</script>

<style scoped>
.chatcontentbox {
  width: 100%;
  height: auto;
  padding-top: 10px;
  padding-bottom: 10px;
}
.pop-right {
  position: relative;
  padding: 5px 10px;
  background-color: #ffffff;
  border-radius: 5px 0 5px 5px;
  margin-right: 10px;
}

.pop-left {
  position: relative;
  padding: 5px 10px;
  background-color: #ffaa99;
  border-radius: 0 5px 5px 5px;
  margin-left: 10px;
}

.ndate {
  font-size: 13px;
  color: #999;
}
</style>
